define('AwaLabs.TurnOffRelatedItems.Main', [
    'SC.Configuration'
],
function TurnOffRelatedItems(
    Configuration
) {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            var layout = application.getComponent('Layout');
            var turnOffRelatedItems = Configuration.get('turnOffRelatedItems.active');

            if (turnOffRelatedItems) {
                layout.removeChildView('Correlated.Items');
                layout.removeChildView('Related.Items');
            }
        }
    };
});
